import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCyberDocuments = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "currentColor",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M2.625 7.5c0-.207.168-.375.375-.375h3a.375.375 0 1 1 0 .75H3.375v15h10.5V20.25a.375.375 0 0 1 .75 0v3a.375.375 0 0 1-.375.375H3a.375.375 0 0 1-.375-.375z",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M5.625 4.5c0-.207.168-.375.375-.375h3a.375.375 0 1 1 0 .75H6.375v15h10.5V17.25a.375.375 0 0 1 .75 0v3a.375.375 0 0 1-.375.375H6a.375.375 0 0 1-.375-.375z",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M8.625.75c0-.207.168-.375.375-.375h7.5c.1 0 .195.04.265.11l4.5 4.5c.07.07.11.166.11.265v12a.375.375 0 0 1-.375.375H9a.375.375 0 0 1-.375-.375zm.75.375v15.75h11.25V5.405l-4.28-4.28z",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M16.5.375c.207 0 .375.168.375.375v4.125H21a.375.375 0 0 1 0 .75h-4.5a.375.375 0 0 1-.375-.375V.75c0-.207.168-.375.375-.375",
			clipRule: "evenodd"
		})
	]
});
export default SvgCyberDocuments;
